export default __webpack_public_path__ + "static/media/logo-text.115597dd.svg";